import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-innovation-filter',
  templateUrl: './innovation-filter.component.html',
  styleUrls: ['./innovation-filter.component.css']
})
export class InnovationFilterComponent implements OnInit {

  @Input() onShowPeriod;

  showStep = 'start';
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/innovation-filter/innovation-filter.component.ts